exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-search-bar-component {\n  width: 100%; }\n  .user-search-bar-component .search-bar {\n    text-align: center;\n    position: relative; }\n    .user-search-bar-component .search-bar .search-result {\n      position: absolute;\n      width: 100%;\n      max-height: 600px;\n      overflow: auto;\n      text-align: left;\n      z-index: 2; }\n      .user-search-bar-component .search-bar .search-result .search-result-item {\n        border: 1px solid #000;\n        background: #ffffff; }\n\n.user-preview-card {\n  padding: 10px; }\n", ""]);

// exports
